import { render, staticRenderFns } from "./TapNFC.vue?vue&type=template&id=bd585de6&"
import script from "./TapNFC.vue?vue&type=script&lang=js&"
export * from "./TapNFC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports